module.exports = __webpack_public_path__ + "img/icon_Image_15.4979b524.png";